import { render, staticRenderFns } from "./eightPage.vue?vue&type=template&id=7643c8e5&scoped=true"
import script from "./eightPage.vue?vue&type=script&lang=js"
export * from "./eightPage.vue?vue&type=script&lang=js"
import style0 from "./eightPage.vue?vue&type=style&index=0&id=7643c8e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7643c8e5",
  null
  
)

export default component.exports